import { useTranslation } from "react-i18next";
import {
  InfoField,
  MetadataSection,
} from "~/molecules/DocumentMetadataSections";
import { type DocumentVersionDetails } from "~/api/types";
import { DueDateCell } from "~/molecules/DueDateCell";

interface Props {
  documentVersion: DocumentVersionDetails;
}

export default function WorkflowDates({
  documentVersion: documentVersion,
}: Props) {
  const { t } = useTranslation();

  const workflowStartedAt = documentVersion.stepInstances[0]?.createdAt;
  const workflowEndedAt = documentVersion.publishedAt;

  return (
    <MetadataSection title={t(($) => $.commons.document.reviewDates)}>
      <div className="grid grid-cols-2">
        <InfoField label={t(($) => $.commons.document.reviewFrom)}>
          <DueDateCell
            dueDate={documentVersion.reviewFrom}
            className={workflowStartedAt ? "text-muted-foreground" : undefined}
            showTriangleAlert={workflowStartedAt === undefined}
          />
        </InfoField>
        <InfoField label={t(($) => $.commons.document.reviewTo)}>
          <DueDateCell
            dueDate={documentVersion.reviewTo}
            className={workflowEndedAt ? "text-muted-foreground" : undefined}
            showTriangleAlert={workflowEndedAt === null}
          />
        </InfoField>
      </div>
    </MetadataSection>
  );
}
